export default __webpack_public_path__ + "static/bannernew-694c842b4e58129399de85d62aeed772.png";